module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/select/dist/mdc.select","commonjs2":"@material/select/dist/mdc.select","commonjs":"@material/select/dist/mdc.select","amd":"@material/select/dist/mdc.select","umd":"@material/select/dist/mdc.select"}
// module id = 52
// module chunks = 0